export const BANNER_LAYOUTS = ['contained', 'full-width'] as const;
export type BannerLayout = (typeof BANNER_LAYOUTS)[number];
